module.exports = __webpack_public_path__ + "img/58800.d1015bf1.jpg";